<template>
  <ModalBase show-modal auto-h on-top @close-modal="close" :overlay-scrollb="false" class="finance-invoice-modal finance-invoice-modal--pbl">
    <template v-slot:titlebar>
      <TitleBar variant-class="title-modal">
        <template v-slot:pretitle>
            {{ $gettext('FINANCE') }}
        </template>
        <template v-slot:title>
          {{ $gettext('Apply for a business loan') }}
        </template>
      </TitleBar>
    </template>
    <template v-slot:maincontent>
      <div v-if="!loading" class="finance-widget-wrap">
        <rabobank-pbl
          :mode="widgetOptions.mode"
          :kvk-number="(currentCompany.kvk && currentCompany.kvk !== '') ? currentCompany.kvk : undefined"
          :contact-details="widgetContactDetails"
          :loan-amount="loanAmount"
        />
      </div>
    </template>
    <template v-slot:actions v-if="currentUserProfile.show_rabo_notification">
      <div class="finance-modal-actions">
        <GekkoButton
          :href="Urls['accounts_notification_settings']()"
          :text="$gettext('Don\'t show again')"
          variant="link"
          size="sm"
        />
      </div>
    </template>
  </ModalBase>
</template>

<script>
import { mapGetters } from "vuex";
import { splitFullName } from "@/utils/";

import TitleBar from "@/components/TitleBar";
import GekkoButton from "@/components/GekkoButton";
import ModalBase from "@/components/base_components/ModalBase";
import LoadingSpinner from "@/components/dashboard/ui/LoadingSpinner"

import { initWidget, subscribeToWidgetEvents } from '@embedded-banking-fundr/pbl'
import '@embedded-banking-fundr/pbl/dist/index.css'

export default {
  name: "InvoiceFinancePBLModal",
  components: {
    ModalBase,
    TitleBar,
    GekkoButton,
    LoadingSpinner,
  },
  props: {

  },
  data () {
    return {
      loading: true,
      widgetContactDetails: null,
      widgetInvoices: null,
      widgetSubscriptionEvents: null,
      loanAmount: null
    }
  },
  computed: {
    ...mapGetters({
      currentUserProfile: 'main/getCurrentUserProfile',
      currentCompany: "main/getCurrentCompany",
      currentUser: "main/getCurrentUser"
    }),
    widgetOptions () {
      const widgetOptions = {
        apiKey: process.env.VUE_APP_RABO_API_KEY,
        partnerId: process.env.VUE_APP_RABO_PARTNER_ID,
        mode: process.env.VUE_APP_RABO_WIDGET_MODE
      }
      if (this.$route.query.fw_mode === 'sandbox') {
        widgetOptions.mode = 'sandbox'
        widgetOptions.partnerId = 'GEKKO'
        widgetOptions.apiKey = 'kM4befCQapljQYQEOQERwnvdDfHo8Y'
      }
      return widgetOptions
    }
  },
  created () {
    this.setupData()
  },
  mounted () {
    document.body.classList.add('modal-on')

    this.widgetSubscriptionEvents = subscribeToWidgetEvents(({ caseId, event, reason }) => {
      const widget_event = {
        'type': event,
        'caseId': caseId,
        'companyId': this.currentCompany.id
      }
      console.log('Rabobank widget event', widget_event)
      if (window.mixpanel) {
        window.mixpanel.track('Rabobank widget event', widget_event)
      }

      if (event === 'error' && reason) {
        // console.log('error:', reason)
        console.log('Rabobank widget error: ' + reason)
        if (window.mixpanel) {
          window.mixpanel.track('Rabobank widget error: ' + reason)
        }
      }

      if (event === 'exit') {
        this.close()
      }
    })
  },
  beforeDestroy () {
    this.widgetSubscriptionEvents.unsubscribe()
  },
  methods: {
    close () {
      this.$emit('close')
      document.body.classList.remove('modal-on')
    },
    setupData () {
      this.loading = true

      const username = splitFullName(this.currentUser.profile.full_name)
       
      this.widgetContactDetails = JSON.stringify({
        name: username.firstName,
        surname: username.surname,
        phone: this.currentCompany.phone_number,
        email: this.currentCompany.created_by.email || this.currentUser.email
      })

      this.loading = false
      // console.log('this.widgetOptions', this.widgetOptions)
      // console.log('initWidget:', {
      //   identifier: this.widgetOptions.apiKey,
      //   partner: this.widgetOptions.partnerId,
      // })

      initWidget({
        identifier: this.widgetOptions.apiKey,
        partner: this.widgetOptions.partnerId,
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>

<style lang="scss">
invoice-finance {
  --rabobank-color-primary: #22AC8A;
  --rabobank-color-secondary: #37A0CD;
  --rabobank-svg-primary: #22AC8A;
  --rabobank-svg-primary-light: #CEF5EB;
  --rabobank-svg-secondary: #37A0CD;
}
.finance-invoice-modal {
  font-size: 1rem;
  .gk-modal {
    max-width: 600px;

    // height: 100% !important;
    // max-height: 996px;
    // min-height: 731px;

    .modal-content-wrap {
      position: relative;
      .finance-widget-wrap {
        padding: 0;

        // height: 100%;

      }
    }
    .finance-modal-actions {
      display: flex;
      justify-content: center;
      border-top: 1px solid $colorBorderDash;
      padding-top: 1rem;
    }
  }
  &--pbl {
    .gk-modal {
      max-height: 947px;
      min-height: 747px;
      height: 100% !important;
      .modal-content-wrap {
        .finance-widget-wrap {
          height: 100%;
        }
      }
    }
  }
}
</style>